module.exports = __webpack_public_path__ + "static/media/bg_POI.026a2fc7.jpg";